export default __webpack_public_path__ + "static/52297-b5469bcdffb89cd2d265423b13b51ca0.jpg";